module.exports = __webpack_public_path__ + "img/VISA_200x120.85db6147.jpg";